module.exports = __webpack_public_path__ + "img/order_banner_picture.27f53fc4.png";